/* Maskal: tel: odkazy na počítači (Claude 15. 10. 2026).
   Na počítači tel: odkaz väčšinou nič nespraví alebo otvorí cudziu appku. Klik preto číslo skopíruje
   a ukáže ho pri odkaze. Na mobile sa nič nemení, odkaz volá ako doteraz. */
(function () {
  var ua = navigator.userAgent || '';
  var mm = window.matchMedia ? function (q) { return window.matchMedia(q).matches; } : function () { return false; };
  if (/Mobi|Android|iPhone|iPod|iPad/i.test(ua) || (mm('(pointer: coarse)') && !mm('(any-pointer: fine)'))) return;
  var cs = (document.documentElement.lang || '').indexOf('cs') === 0;
  function pekne(d) {
    var m = /^(\+421|\+420)(\d{3})(\d{3})(\d{3})$/.exec(d);
    return m ? (m[1] === '+421' ? '0' + m[2] + ' ' + m[3] + ' ' + m[4] : m[1] + ' ' + m[2] + ' ' + m[3] + ' ' + m[4]) : d;
  }
  function kopiruj(t) {
    if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(t).then(function () { return true; }, function () { return false; });
    var a = document.createElement('textarea'); a.value = t; a.setAttribute('readonly', ''); a.style.position = 'fixed'; a.style.opacity = '0';
    document.body.appendChild(a); a.select(); var ok = false; try { ok = document.execCommand('copy'); } catch (e) {}
    document.body.removeChild(a); return Promise.resolve(ok);
  }
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href^="tel:"]') : null;
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey) return;
    e.preventDefault();
    var cislo = pekne(decodeURIComponent(a.getAttribute('href').slice(4)).replace(/[^\d+]/g, ''));
    kopiruj(cislo).then(function (ok) {
      var b = a.nextElementSibling && a.nextElementSibling.classList.contains('mk-tel-info') ? a.nextElementSibling : null;
      if (!b) { b = document.createElement('span'); b.className = 'mk-tel-info'; b.setAttribute('role', 'status'); a.insertAdjacentElement('afterend', b); }
      b.textContent = cislo + (ok ? (cs ? ' · zkopírováno' : ' · skopírované') : '');
    });
  });
  var s = document.createElement('style');
  s.textContent = '.mk-tel-info{display:block;margin-top:8px;font-size:14px;font-weight:500;user-select:all}';
  document.head.appendChild(s);
})();
